module.exports =  {
  home: {
    home:"Home",
    about: "About us",
    research: "Independent R&D",
    quality: "Strict Quality Control",
    academic: "Global Academic",
    dynamic: "Company dynamic",
    news: "Market News",
    product: "Products",
    contact: "Contact us",
    beijing: "beijing",
    address: "Address",
    bjAddress: "Building 1, 30 Yongchang South Road, Beijing Economic and Technological Development Zone, Beijing, China",
    shanghai: "shanghai",
    shAddress: "No.8, West Road, Changning District, Shanghai, China",
    copyright: "copy right",
    companyName: "Beijing iKey Medical Co., LTD",
    more: "More",
    noMoreData: "No More Data",
    seeMore:'See More',
    personnelEmail:'Personnel email',
    salesEmail:'Sales mailbox',
    marketTel:'Tel',
    email:'Email',
    contactPhoneText:'Contact phone number',
    contactPhoneTel:'+86 010 67850177/+86 18519401755 (for domestic cooperation)'
  }
}
